/**
 * Module-scoped fallback counter, used only when `crypto.randomUUID` is unavailable (e.g. older
 * runtimes/environments without Web Crypto).
 */
let fallbackCounter = 0;

function randomUUID(): string | undefined {
    return globalThis.crypto?.randomUUID?.();
}

/**
 * Generate a unique id. Prefers `crypto.randomUUID()`; falls back to a monotonically-increasing, module-scoped
 * counter (`${prefix ?? 'id'}-${n}`) when Web Crypto isn't available.
 */
export function generateId(prefix?: string): string {
    const uuid = randomUUID();

    if (uuid) {
        return uuid;
    }

    return `${prefix ?? 'id'}-${fallbackCounter++}`;
}
